<template>
  <div>
    <!-- header -->
    <div class="fd-head">
      <div class="select-wp">
        <div class="select-box" style="width: 200px">
          <select id="sel_semester" name="">
            <option
              :value="item.Id"
              v-for="(item, idx) in semesterList"
              :key="idx"
            >
              {{ item.Name }} 学期
            </option>
          </select>
        </div>
      </div>
      <h3>企业经济活动国家级虚拟仿真实验教学示范中心</h3>
      <h4>实验室开课数据面板（本学期）</h4>
      <!-- 链接 -->
      <div class="page-fl">
        <router-link :to="'/data3'">
          <div class="fd-weekbutton">
            <span class="fd-week-ico fd-weekfl"></span>
            <span class="fd-weektext">上一页</span>
          </div>
        </router-link>
      </div>
      <div class="page-fr">
        <router-link :to="'/'">
          <div class="fd-weekbutton">
            <span class="fd-weektext">下一页</span>
            <span class="fd-week-ico fd-weekfr"></span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- fl 总课程数-->
    <div class="fd-fl" style="width: 38%">
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">总课程数</span>
          <div class="line" style="50%"></div>
        </div>
        <div class="content">
          <div class="fd-data fd-data-small">
            <ul>
              <li>
                <span class="fd-data-ico fd-data-course"></span>
                <span class="fd-data-name">总开课数量</span>
                <span class="fd-data-num">{{ statModel.totalCourseNum }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-time"></span>
                <span class="fd-data-name">总实验时数</span>
                <span class="fd-data-num">{{ statModel.totalHours }}</span>
              </li>
              <li>
                <span class="fd-data-ico fd-data-people"></span>
                <span class="fd-data-name">总实验人数</span>
                <span class="fd-data-num">{{ statModel.totalNumber }}</span>
              </li>
            </ul>
          </div>
          <div
            id="fd-pie1"
            style="width: 100%; height: 520px; margin: 90px 0 82px 0"
          ></div>
        </div>
      </div>
    </div>
    <!-- fr 数量以及进度 -->
    <div class="fd-fr" style="width: 59%; margin-right: 20px">
      <div class="demo-w demo-box mar-bot">
        <div class="title">
          <span class="txt fd-tit">各系课程数量以及进度</span>
          <div class="line"></div>
        </div>
        <div class="content">
          <div class="fa-cur dis-fa-cur" style="float: none">
            <span class="cur" @click="departmentChange(0)">全部</span>
            <template v-for="(item, index) in statModel.groups">
              <span
                v-if="item.department.length < 4"
                :key="index"
                style="margin-bottom: 10px"
                @click="departmentChange(item.id)"
                >{{ item.department }}</span
              >
              <span
                v-else
                :key="index"
                style="font-size: 12px; margin-bottom: 10px"
                @click="departmentChange(item.id)"
                >{{ item.department }}</span
              >
            </template>
          </div>
          <div class="fd-grid">
            <ul>
              <li>
                <div id="fd-pie2" style="width: 100%; height: 300px"></div>
              </li>
              <li>
                <div id="fd-pie3" style="width: 100%; height: 300px"></div>
              </li>
              <li>
                <div id="fd-pie4" style="width: 100%; height: 300px"></div>
              </li>
              <li>
                <div id="fd-pie5" style="width: 100%; height: 300px"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<script>
import $ from '../../static/js/jquery.min.js'
import echarts from 'echarts'
import {
  getApi
} from '../../static/js/api.js'
export default {
  data () {
    return {
      statModel: {
        totalCourseNum: 0,
        totalHours: 0,
        totalNumber: 0,
        groups: []
      },
      semesterId: 0,
      departmentId: 0,
      semesterList: []
    }
  },
  mounted () {
    let that = this
    that.getSemesterList()
    that.GetNowSemesterAndWeek()
  },
  methods: {
    getSemesterList () {
      let that = this
      getApi('/Semester/GetAll').then(res => {
        if (res.IsSuccess) {
          this.semesterList = res.SuccessData
          setTimeout(() => {
            $("select").selectOrDie()
            $("#sel_semester").change(function () {
              that.GetNowSemesterAndWeek($(this).find('option:selected').val())
            })
          }, 500)
        }
      })
    },
    GetNowSemesterAndWeek (semesterId) {
      let that = this
      getApi('/bi/GetNowSemesterAndWeek', { semesterId: semesterId }, 'Post').then(res => {
        if (res.IsSuccess) {
          that.semesterId = res.SuccessData.Semester.Id
        }
        that.LoadStat()
      })
    },
    departmentChange (id) {
      this.departmentId = id
      console.log(id)
      this.LoadStat()
    },
    LoadStat () {
      let that = this
      getApi('/bi/GetDepartmentCourseStat', {
        semesterId: that.semesterId,
        departmentId: that.departmentId
      }, 'Post').then(r => {
        that.statModel = r.SuccessData
        // 总数据
        var myChartPie1 = echarts.init(document.getElementById('fd-pie1'));
        var option1 = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            right: '10%'
          },
          legend: {
            data: ['时数', '人数'],
            textStyle: {
              color: '#aaecff'
            }
          },
          xAxis: [{
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            axisLine: {
              lineStyle: {
                color: '#aaecff'
              }
            },
            data: that.statModel.groups.map(v => v.department),
            axisLabel: {
              interval: 0,
              margin: 20,
              align: 'center',
              formatter: function (value, index) {
                // 格式化成月/日，只在第一个刻度显示年份
                if (value.length > 4) {
                  return value.substring(0, 4) + '...';
                }
                return value;
              }
            }
          }],
          yAxis: [{
            type: 'value',
            name: '时数',
            min: 0,
            position: 'right',
            axisLine: {
              lineStyle: {
                color: '#aaecff'
              }
            },
            splitLine: {
              lineStyle: {
                color: '#1b3676'
              }
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '人数',
            min: 0,
            position: 'left',
            axisLine: {
              lineStyle: {
                color: '#aaecff'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
          ],
          series: [{
            name: '时数',
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              color: '#0084ff'

            },
            data: that.statModel.groups.map(v => v.hours),
            avoidLabelOverlap: true,
          },
          {
            name: '人数',
            type: 'bar',
            barWidth: '30%',
            yAxisIndex: 1,
            itemStyle: {
              color: '#c79232'

            },
            data: that.statModel.groups.map(v => v.peopleNum),
            avoidLabelOverlap: true,
          }
          ]
        };
        myChartPie1.setOption(option1, true);

        // 数量以及进度
        var myChartPie2 = echarts.init(document.getElementById('fd-pie2'));
        var option2 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}({d}%)'
          },
          graphic: {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: '总课程\n\n' + (that.statModel.courseCount.completedCount + that.statModel.courseCount.undoneCount + that.statModel.courseCount.processing),
              textAlign: 'center',
              lineHeight: '80',
              fill: '#08d7ed',
              fontSize: '20',
              fontFamily: 'Microsoft YaHei',
              fontWeight: 'bold'
            }
          },
          series: [
            {
              name: '总课程',
              type: 'pie',
              radius: ['45%', '65%'],
              avoidLabelOverlap: true,
              label: {
                show: true,
                formatter: '{b}\n {@2012}门',
                color: '#fff',
                // lineHeight:'100',
                fontSize: '16'
              },
              itemStyle: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: '#079342',
                      c2: '#11d6a1'
                    },
                    {

                      c1: '#de79e3',
                      c2: '#831ab5'
                    },
                    {
                      c1: '#17abe7',
                      c2: '#0f58b6'
                    }
                  ]
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    offset: 0,
                    color: colorList[params.dataIndex].c1
                  }, {
                    offset: 1,
                    color: colorList[params.dataIndex].c2
                  }])
                },
              },
              data: [
                { value: that.statModel.courseCount.undoneCount, name: '未开始' },
                { value: that.statModel.courseCount.processing, name: '进行中' },
                { value: that.statModel.courseCount.completedCount, name: '已完成' }
              ]
            }
          ]
        };
        myChartPie2.setOption(option2, true);

        //独立设置实验课
        var myChartPie3 = echarts.init(document.getElementById('fd-pie3'));
        var option3 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}({d}%)'
          },
          graphic: {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: '独立实验课\n\n' + (that.statModel.duliCourseCount.completedCount + that.statModel.duliCourseCount.undoneCount + that.statModel.duliCourseCount.processing),
              textAlign: 'center',
              lineHeight: '80',
              fill: '#08d7ed',
              fontSize: '20',
              fontFamily: 'Microsoft YaHei',
              fontWeight: 'bold'
            }
          },
          series: [
            {
              name: '总课程',
              type: 'pie',
              radius: ['45%', '65%'],
              avoidLabelOverlap: true,
              label: {
                show: true,
                formatter: '{b}\n {@2012}门',
                color: '#fff',
                // lineHeight:'100',
                fontSize: '16'
              },
              itemStyle: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: '#079342',
                      c2: '#11d6a1'
                    },
                    {

                      c1: '#de79e3',
                      c2: '#831ab5'
                    },
                    {
                      c1: '#17abe7',
                      c2: '#0f58b6'
                    }
                  ]
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    offset: 0,
                    color: colorList[params.dataIndex].c1
                  }, {
                    offset: 1,
                    color: colorList[params.dataIndex].c2
                  }])
                },
              },
              data: [
                { value: that.statModel.duliCourseCount.undoneCount, name: '未开始' },
                { value: that.statModel.duliCourseCount.processing, name: '进行中' },
                { value: that.statModel.duliCourseCount.completedCount, name: '已完成' }
              ]
            }
          ]
        };
        myChartPie3.setOption(option3, true);

        //非独立设置实验课
        var myChartPie4 = echarts.init(document.getElementById('fd-pie4'));
        var option4 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}({d}%)'
          },
          graphic: {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: '非独立实验课\n\n' + (that.statModel.feiduliCourseCount.completedCount + that.statModel.feiduliCourseCount.undoneCount + that.statModel.feiduliCourseCount.processing),
              textAlign: 'center',
              lineHeight: '80',
              fill: '#08d7ed',
              fontSize: '20',
              fontFamily: 'Microsoft YaHei',
              fontWeight: 'bold'
            }
          },
          series: [
            {
              name: '总课程',
              type: 'pie',
              radius: ['45%', '65%'],
              avoidLabelOverlap: true,
              label: {
                show: true,
                formatter: '{b}\n {@2012}门',
                color: '#fff',
                // lineHeight:'100',
                fontSize: '16'
              },
              itemStyle: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: '#079342',
                      c2: '#11d6a1'
                    },
                    {

                      c1: '#de79e3',
                      c2: '#831ab5'
                    },
                    {
                      c1: '#17abe7',
                      c2: '#0f58b6'
                    }
                  ]
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    offset: 0,
                    color: colorList[params.dataIndex].c1
                  }, {
                    offset: 1,
                    color: colorList[params.dataIndex].c2
                  }])
                },
              },
              data: [
                { value: that.statModel.feiduliCourseCount.undoneCount, name: '未开始' },
                { value: that.statModel.feiduliCourseCount.processing, name: '进行中' },
                { value: that.statModel.feiduliCourseCount.completedCount, name: '已完成' }
              ]
            }
          ]
        };
        myChartPie4.setOption(option4, true);

        //其他课程
        var myChartPie5 = echarts.init(document.getElementById('fd-pie5'));
        var option5 = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c}({d}%)'
          },
          graphic: {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: '其他实验课\n\n' + (that.statModel.otherCourseCount.completedCount + that.statModel.otherCourseCount.undoneCount + that.statModel.otherCourseCount.processing),
              textAlign: 'center',
              lineHeight: '80',
              fill: '#08d7ed',
              fontSize: '20',
              fontFamily: 'Microsoft YaHei',
              fontWeight: 'bold'
            }
          },
          series: [
            {
              name: '总课程',
              type: 'pie',
              radius: ['45%', '65%'],
              avoidLabelOverlap: true,
              label: {
                show: true,
                formatter: '{b}\n {@2012}门',
                color: '#fff',
                // lineHeight:'100',
                fontSize: '16'
              },
              itemStyle: {
                color: function (params) {
                  var colorList = [
                    {
                      c1: '#079342',
                      c2: '#11d6a1'
                    },
                    {

                      c1: '#de79e3',
                      c2: '#831ab5'
                    },
                    {
                      c1: '#17abe7',
                      c2: '#0f58b6'
                    }
                  ]
                  return new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                    offset: 0,
                    color: colorList[params.dataIndex].c1
                  }, {
                    offset: 1,
                    color: colorList[params.dataIndex].c2
                  }])
                },
              },
              data: [
                { value: that.statModel.otherCourseCount.undoneCount, name: '未开始' },
                { value: that.statModel.otherCourseCount.processing, name: '进行中' },
                { value: that.statModel.otherCourseCount.completedCount, name: '已完成' }
              ]
            }
          ]
        };
        myChartPie5.setOption(option5, true);
      }).finally(() => {
        $(".fa-cur span").unbind();
        $(".fa-cur span").click(function () {
          $(this).addClass("cur").siblings().removeClass("cur");
        });
      })
    }
  }
}
</script>

<style>
</style>
